import { List } from "@mui/material";
import type { LeaderboardEntryResponse } from "@bw/shared/types/generated";
import { LadderRow } from "./LadderRow";

export function LeaderboardTable({
  rows,
  myUserId,
}: {
  rows: LeaderboardEntryResponse[];
  myUserId?: string;
}) {
  return (
    <List disablePadding data-testid="leaderboard" aria-label="Leaderboard">
        {rows.map((row) => (
          <LadderRow
            key={row.user_id}
            row={row}
            position={row.rank}
            isSelf={myUserId != null && row.user_id === myUserId}
          />
        ))}
    </List>
  );
}
